import { RedeemProps } from "@/models";
import { Api } from "@/services";
import { Api_Banking } from "@/services/Api/bankingApiConfig";
import { getAPIN8N } from "@/services/Api/n8nApiConfig";
import { filterAndPageableToRequest, formatCurrency, showToast } from "@/utils";
import { useState } from "react";

export function useRedeem() {
  const baseUrl = "/redeems";
  const fraudBaseUrl = "/sellers/anti-fraud";
  const Api_N8N = getAPIN8N();
  const Api_N8N_LEDGER = getAPIN8N("", true);
  const [initialData, setInitialData] = useState({} as RedeemProps);
  const [balanceInitialData, setBalanceInitialData] = useState({} as any);
  const [isLoading, setIsLoading] = useState(false);
  const getReedemAmount = () => {
    return Api.get(baseUrl);
  }
  const getRedeems = (filter: object, pageable: object) => {
    return Api.get(
      `${baseUrl}/statement${filterAndPageableToRequest({ filter, pageable })}`
    );
  };

  const getRedeemCSV = (filter: object, pageable: object) => {
    return Api.get(
      `${baseUrl}/statement/csv${filterAndPageableToRequest({
        filter,
        pageable,
      })}`
    );
  };

  const getSellerAnticipationAmount = (data) => {
    return Api.post(
      `${baseUrl}/anticipation/amount`, data
    )
  }

  const getSellerFraud = (id) => {
    return Api.get(`${fraudBaseUrl}`);
  }

  const getBalance = () => {
    return Api_Banking.get(`accounts/balance`);
  }

  const getLedger = (account_type: string, start_date: string, end_date: string) => {
    if (start_date && end_date) {
      return Api_N8N_LEDGER.get(`v1/ledger?account=${account_type}&start_date=${start_date}&end_date=${end_date}`);
    }
    return Api_N8N_LEDGER.get(`v1/ledger?account=${account_type}`);
  }

  const getFuturePostings = () => {
    return Api_N8N.get(`v1/banking/withdrawals`);
  }

  async function getInitialData(filter: object, pageable: object, isShortRedeemData?: boolean) {

    setIsLoading(true);
    try {
      let initialDataObject;
      if (isShortRedeemData) {
        const amount_response: any = await getReedemAmount();
        const formatAmountToCurrency = formatCurrency({ value: amount_response.data.amount })
        const formatOnDemandNetAmount = formatCurrency({ value: amount_response.data.onDemandNetAmount })
        const formatProvisionedAmountToCurrency = formatCurrency({ value: amount_response.data.provisionedAmount })
        const formatTotalAmountValue = formatCurrency({ value: amount_response.data.amount + amount_response.data.provisionedAmount }).split("R$")


        initialDataObject = {
          ...initialDataObject,
          amount: formatAmountToCurrency,
          onDemandNetAmount: formatOnDemandNetAmount,
          isOnDemandEnabled: amount_response.data.isOnDemandEnabled,
          notFormattedAmount: amount_response.data.amount,
          provisionedAmount: formatProvisionedAmountToCurrency,
          amountToAnticipation: formatCurrency({ value: amount_response.data.amountToAnticipation }),
          bankingType: amount_response.data.bankingType,
          totalAmount: formatTotalAmountValue,
        }
        setInitialData(initialDataObject);
        return
      }
      const redeems_response = await getRedeems(filter, pageable);
      const amount_response: any = await getReedemAmount();
      const formatOnDemandNetAmount = formatCurrency({ value: amount_response.data.onDemandNetAmount })
      const formatAmountToCurrency = formatCurrency({ value: amount_response.data.amount })
      const formatProvisionedAmountToCurrency = formatCurrency({ value: amount_response.data.provisionedAmount })
      const formatTotalAmountValue = formatCurrency({ value: amount_response.data.amount + amount_response.data.provisionedAmount }).split("R$")
      initialDataObject = {
        ...initialDataObject,
        amount: formatAmountToCurrency,
        provisionedAmount: formatProvisionedAmountToCurrency,
        notFormattedAmount: amount_response.data.amount,
        totalAmount: formatTotalAmountValue,
        onDemandNetAmount: formatOnDemandNetAmount,
        isOnDemandEnabled: amount_response.data.isOnDemandEnabled,

        amountToAnticipation: formatCurrency({ value: amount_response.data.amountToAnticipation }),
        ...redeems_response.data
      }
      setInitialData(initialDataObject);
    } catch (error) {
      showToast({
        type: "error",
        message: "Falha no carregamento dos repasses.",
      });
    } finally {
      setIsLoading(false);
    }
  }

  async function getBalanceInitialData() {
    try {
      const balance_response = await getBalance();
      const formatAccountBalance = {
        totalAmount: formatCurrency({ value: balance_response.data.debitAccountAmount }).split("R$")[1],
      }
      setBalanceInitialData(formatAccountBalance);
    } catch (error) {
      showToast({
        type: "error",
        message: "Falha no carregamento do saldo da conta corrente.",
      });
    }
  }

  return {
    initialData,
    isLoading,
    getRedeems,
    getRedeemCSV,
    getInitialData,
    getReedemAmount,
    getSellerAnticipationAmount,
    getSellerFraud,
    getBalanceInitialData,
    getBalance,
    getLedger,
    balanceInitialData,
    getFuturePostings,
  };
}
